import Page from '../Page';
import type { PageProps } from '../Page/Page';
import ErrorScreen, { makeDataTestId as errorMakeDataTestId } from '../../molecules/ErrorScreen';
import TopOfPageCustomizationArea from '../../organisms/TopOfPageCustomizationArea';

export const makeDataTestId = (dataTestId = 'error-page') => {
  return {
    ...errorMakeDataTestId(dataTestId),
    button: `${dataTestId}.button`,
  };
};

export interface ErrorPageProps extends Omit<PageProps, 'children' | 'title'> {
  errorMessage: string;
  dataTestId?: string;
  onActionClick: VoidFunction;
  reasonMessage?: string;
  actionMessage: string;
  hideButton?: boolean;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  dataTestId,
  errorMessage,
  reasonMessage,
  onActionClick,
  actionMessage,
  hideButton,
  ...pageProps
}) => {
  const allDataTestId = makeDataTestId(dataTestId);

  return (
    <Page topBanner={<TopOfPageCustomizationArea />} hideCurrencySelector {...pageProps} title={errorMessage}>
      <ErrorScreen
        title={errorMessage}
        text={reasonMessage}
        dataTestId={allDataTestId.prefix}
        onActionClick={onActionClick}
        actionMessage={actionMessage}
        hideButton={hideButton}
      />
    </Page>
  );
};

export default ErrorPage;
